import { Switch, Route, Redirect } from "react-router-dom";
import { SingleCard } from "./layouts";
import { LoginForm, ResetPasswordForm, ChangePasswordForm } from "./components";
import icons from "./assets/images";
import { useSelector } from "react-redux";
import { getLocalized } from "./redux/localization";

export default function UnauthenticatedContent() {
  const strings = useSelector(getLocalized);
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        style={{ width: 150, marginBlockEnd: 30 }}
        src={icons.uklogoBackgroundEmpty}
        alt=""
      />
      <Switch>
        <Route exact path="/login">
          <SingleCard title={strings.getString("signin")}>
            <LoginForm />
          </SingleCard>
        </Route>
        {/* <Route exact path="/create-account">
          <SingleCard title="Sign Up">
            <CreateAccountForm />
          </SingleCard>
        </Route> */}
        <Route exact path="/reset-password">
          <SingleCard
            title={strings.getString("reset_password")}
            description={strings.getString("reset_password_description")}
          >
            <ResetPasswordForm />
          </SingleCard>
        </Route>
        <Route exact path="/change-password/:recoveryCode">
          <SingleCard title="Change Password">
            <ChangePasswordForm />
          </SingleCard>
        </Route>
        <Redirect to={"/login"} />
      </Switch>
    </div>
  );
}
